import cn from 'classnames';

import useIsScreenSize from 'js/hooks/use-is-screen-size';

import Accordion from 'components/accordion/Accordion';
import ChapterLink from 'components/chapter-link/ChapterLink';
import ChapterNavigationList from './ChapterNavigationList';

import { ITableOfContents } from 'source/NFR.types';

const TableOfContents: React.FC<ITableOfContents> = ({ items = [], title, accordion }) => {
  const isDesktop = useIsScreenSize('lg');

  return (
    <Accordion expandOnMount={windowWidth => windowWidth >= 1024} {...accordion}>
      {({ Button, Collapse, isOpen, toggle }) => {
        if (!isOpen && isDesktop) {
          toggle();
        }

        return (
          <div className="table-of-contents">
            <div className="table-of-contents__content">
              <div className="table-of-contents__header">
                {isDesktop && title && <h2 className="table-of-contents__title">{title}</h2>}
                {!isDesktop && (
                  <Button
                    icon="micro-arrow-down"
                    className={cn('table-of-contents__button', {
                      'table-of-contents__button--is-active': isOpen
                    })}
                  >
                    {title && <h2 className="table-of-contents__title">{title}</h2>}
                  </Button>
                )}
              </div>
              <Collapse>
                <ul className="table-of-contents__list">
                  {items?.map(({ link, linkOrLinkList }, index) => {
                    if (link) {
                      return (
                        <li className="table-of-contents__list-item" key={link.chapterNumber + String(index)}>
                          <ChapterLink {...link} isTopLevelLink={true} />
                        </li>
                      );
                    }

                    if (linkOrLinkList) {
                      return (
                        <li
                          className="table-of-contents__list-item"
                          key={`${linkOrLinkList.link?.chapterNumber ?? ''}-${index}`}
                        >
                          <ChapterNavigationList {...linkOrLinkList} />
                        </li>
                      );
                    }

                    return null;
                  })}
                </ul>
              </Collapse>
            </div>
          </div>
        );
      }}
    </Accordion>
  );
};

TableOfContents.displayName = 'TableOfContents';

export default TableOfContents;
